
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useParams } from 'react-router';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { UserContext } from '../../../context/user-context';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { FaTicketAlt } from 'react-icons/fa'

import './attendee.css'

export default function Attendee() {
	const [attendee, setAttendee] = useState(null);
	const [loading, setLoading] = useState(true);
  const { user_id } = useParams();
  const { userToken, user } = useContext(UserContext);
  const breadcrumbs = useBreadcrumbs();
  const [upcomingTickets, setUpcomingTickets] = useState([]);

  useEffect(() => {
		if (!user) {
			return;
		}
  	getAttendeeData();
		getTickets();
  }, []);

  const getAttendeeData = () => {
    const time = new Date().getTime();
    const api_url = process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/members/${user_id}?timestamp=${time}&my_attendance=true`;
    axios.get(api_url, {
      headers: {
        'Authorization': 'Basic ' + btoa(user?.user_login + ":" + userToken),
      },
    }).then((res) => {
      setAttendee(res.data.data);
    }).catch((err) => {
      console.error(err);
      alert('Error ⚠️! Faild to get attendee data.');
    }).finally(() => {
    	// console.log('done loading')
      setLoading(false);
    });
  }

	const getTickets = () => {
		setLoading(true);
		const time = new Date().getTime();
		const api_url = process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/user/tickets?timestamp=` + time;
		// To Do: change endpoint to be `/wp-json/gnetwork/v1/user/{user_id}/tickets`
		axios.get(api_url, {
			headers: {
        'Authorization': 'Basic ' + btoa(user?.user_login + ":" + userToken),
			}
		}).then((res) => {
			console.log('getTickets', res.data)
			if (res.data.success) {
				setUpcomingTickets(res.data.upcoming_tickets);
				// setPastTickets(res.data.past_tickets);
			}
		}).catch((err) => {
			console.log(err.message)
			console.log(err.response.data)
			alert('Error ⚠️! Failed to load upcoming tickets.');
		}).finally(() => {
			setLoading(false);
		});
	}

  if (loading) {
	  return (
			<Container>
	      <Row>
	        <Col>
	          <p>Loading...</p>
	        </Col>
	      </Row>
			</Container>
	  );
  }

	return (
		<Container>
			{attendee && (
				<>
					<Breadcrumb>
						{breadcrumbs.map(({ breadcrumb, key, location, match }, index) => {
							breadcrumb = ((key === ('/attendees/' + user_id)) ? attendee.name : breadcrumb)
							return <Breadcrumb.Item key={index} href={key}>{breadcrumb}</Breadcrumb.Item>
						})}
					</Breadcrumb>
					<Row style={{ rowGap: '1rem' }}>
						<Col lg="4">
							<div className="card">
								<div className="card-body">
									{attendee?.image.url && (
										<img className="attendee-img" src={attendee?.image.url} alt={attendee.name} loading="lazy"/>
									)}
									<h1>{attendee.name}</h1>
									<p className="text-silver">{attendee.occupation}</p>
									<p>Contact Info</p>
									<p className="text-silver">{attendee.email}</p>
								</div>
							</div>
						</Col>
						<Col lg="8">
							<div className="card">
								<div className="card-body">
									<h2 className="fs-1.5x">Upcoming Tickets</h2>
									{(!loading && upcomingTickets.length == 0) && (
										<p><FaTicketAlt/> Upcoming tickets appear here.</p>
									)}
									<h2 className="fs-1.5x">Events Attended</h2>
									{attendee.my_attendance && (
										<ul className="attendee-events-attended">
											{attendee.my_attendance.map((event, key) => {
												const event_title = event.title.replace('&#038;', '&').replace('&#8217;', '');
												return (
													<li className="attendee-event" key={key}>{event_title}</li>
												);
											})}
										</ul>
									)}
								</div>
							</div>
						</Col>
					</Row>
				</>
			)}
		</Container>
	);
}
